import React, { Component } from 'react';
import {
  set,
} from 'lodash';

import InfluencerRatesTableComponent from './influencer-rates-table';

class InfluencerRatesTable extends Component {
  static propTypes = {
  };
  constructor(props) {
    super(props);
    const {
      facebook,
      facebookCount,
      facebookRates,
      instagram,
      instagramCount,
      instagramRates,
      twitter,
      twitterCount,
      twitterRates,
      youtube,
      youtubeCount,
      youtubeChannelTitle,
      youtubeRates,
      web,
      webRates,
      pinterest,
      pinterestRates,
      currency,
      tiktok,
      tiktokCount,
      tiktokRates,
      twitch,
      twitchCount,
      twitchRates,
      snapchat,
      snapchatRates,
      telegram,
      telegramRates,
      others,
      othersRates,
    } = props;
    this.state = {
      facebook,
      facebookCount,
      facebookRates,
      instagram,
      instagramCount,
      instagramRates,
      twitter,
      twitterCount,
      twitterRates,
      youtube,
      youtubeCount,
      youtubeChannelTitle,
      youtubeRates,
      web,
      webRates,
      pinterest,
      pinterestRates,
      currency,
      tiktok,
      tiktokCount,
      tiktokRates,
      twitch,
      twitchCount,
      twitchRates,
      snapchat,
      snapchatRates,
      telegram,
      telegramRates,
      others,
      othersRates,
    };
  }

  handleEdit = () => {
    this.setState({
      editing: true,
    });
  }

  handleSave= () => {
    const {
      onSave,
    } = this.props;
    this.setState({
      editing: false,
    }, () => onSave(this.state));
  }

  handleCancel = () => {
    this.setState({
      editing: false,
    });
  }

  handleChange = (e, { name, value }) => {
    this.setState(
      set({ ...this.state }, name, value),
    );
  }

  render = () => {
    const {
      editing,
      facebook,
      facebookCount,
      facebookRates,
      instagram,
      instagramCount,
      instagramRates,
      twitter,
      twitterCount,
      twitterRates,
      youtube,
      youtubeCount,
      youtubeChannelTitle,
      youtubeRates,
      web,
      webRates,
      pinterest,
      pinterestRates,
      currency,
      tiktok,
      tiktokCount,
      tiktokRates,
      twitch,
      twitchCount,
      twitchRates,
      snapchat,
      snapchatRates,
      telegram,
      telegramRates,
      others,
      othersRates,
    } = this.state;
    return (<InfluencerRatesTableComponent
      editing={editing}
      facebook={facebook}
      facebookCount={facebookCount}
      facebookRates={facebookRates}
      instagram={instagram}
      instagramCount={instagramCount}
      instagramRates={instagramRates}
      twitter={twitter}
      twitterCount={twitterCount}
      twitterRates={twitterRates}
      youtube={youtube}
      youtubeCount={youtubeCount}
      youtubeChannelTitle={youtubeChannelTitle}
      youtubeRates={youtubeRates}
      web={web}
      webRates={webRates}
      pinterest={pinterest}
      pinterestRates={pinterestRates}
      tiktok={tiktok}
      tiktokCount={tiktokCount}
      tiktokRates={tiktokRates}
      twitchCount={twitchCount}
      twitch={twitch}
      twitchRates={twitchRates}
      snapchat={snapchat}
      snapchatRates={snapchatRates}
      telegram={telegram}
      telegramRates={telegramRates}
      onEdit={this.handleEdit}
      onCancel={this.handleCancel}
      onSave={this.handleSave}
      onChange={this.handleChange}
      currency={currency}
      others={others}
      othersRates={othersRates}
    />);
  }
}
export default InfluencerRatesTable;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-rates-table/index.js
 **/